import { combineReducers } from "redux";
import reducers from "./modules/buttonIsShowen";

export default combineReducers({ reducers });
